import React, {useState, useEffect, useCallback} from 'react';
import {Link} from 'react-router-dom'
import {httpGet} from '../shared/Config';
import {Button} from 'reactstrap'
import OrganizationModal from './OrganizationModal'
import SectionList from '../shared/SectionList'
import DepartmentRequestModal from './DepartmentRequestModal';
import BuyGlobalDocumentsModal from './BuyGlobalDocumentsModal'
import AssignDocumentsModal from './AssignDocumentsModal';
import AssignTimestampsModal from './AssignTimestampsModal';
import UpdateRegimenFiscal from '../shared/UpdateRegimenFiscal';
import StripeSessionData from "./StripeSessionData";
import UpdateRegimenFiscalInline from "../shared/UpdateRegimenFiscalInline";
import BuyGlobalDocumentsInline from "./BuyGlobalDocumentsInline";

import SpeiInfoModal from '../shared/SpeiInfoModal';

import { useTranslation } from 'react-i18next';
import BuyGlobalIdentityVerificationsModal from "./BuyGlobalIdentityVerificationsModal";
import BuyGlobalWhatsAppMessages from "./BuyGlobalWhatsAppMessages";
import Section from "../shared/Section";
import ShoppingCart from '../ShoppingCart';
import {Icon} from "@iconify/react";
import InvoiceDataModal from '../invoiceData/InvoiceDataModal'

function DropdownItemWithPaymentLabel({children, pendingPayment, ...props}) {
    const {t} = useTranslation();
    return (
        <li
            {...props}>
            <a className={'block'}>
                {children}
                {
                    pendingPayment ?
                        <span>{t('BLOCKED_BY_PENDING_PAYMENT')}</span>
                        : null
                }
            </a>
        </li>
    )
}


function Organizations({history}) {

    const {t} = useTranslation()
    const [tenant, setTenant] = useState({});
    const [mode, setMode] = useState("ALL");

    const [serverConf, setServerConf] = useState({});
    const [allowPurchases, setAllowPurchases] = useState(false);
    const [currency, setCurrency] = useState("");
    const [ivaIncluded, setIvaIncluded] = useState(true);
    const [blockSpei, setBlockSpei] = useState(false);

    const [companyActive, setCompanyActive] = useState(false);
    const [companyActiveCheck, setCompanyActiveCheck] = useState(false);

    const [subFetch, setSubFetch] = useState(false);
    const [subscriptionActive, setSubscriptionActiveCheck] = useState(true);

    const [companyCheck, setCompanyCheck] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [companyId, setCompanyId] = useState(0);
    const [companyNameNotUpdated, setCompanyNameNotUpdated] = useState(false);
    const [organizationFetchDone, setOrganizationsFetchDone] = useState(false)

    const [remainingDocs, setRemainingDocs] = useState({});
    const [remainingSubscriptionDocs, setRemainingSubscriptionDocs] = useState({});
    const [remainingVerifications, setRemainingVerifications] = useState({});
    const [remainingAllowedVerifications, setRemainingAllowedVerifications] = useState();
    const [pendingLockingVerificationsPayments, setPendingLockingVerificationsPayments] = useState();

    const [remainingWhatsAppMessages, setRemainingWhatsAppMessages] = useState({})
    const [remainingAllowedWhatsAppMessages, setRemainingAllowedWhatsAppMessages] = useState()
    const [pendingLockingWhatsAppMessagesPayments, setPendingLockingWhatsAppMessagesPayments] = useState()

    const [showSpeiInfo, setShowSpeiInfo] = useState({
        open: false
    });

    const [remainingTimestamps, setRemainingTimestamps] = useState({});

    const [accountStatus, setAccountStatus] = useState({});

    const [remainingAllowedDocuments, setRemainingAllowedDocuments] = useState();
    const [pendingLockingDocumentsPayments, setPendingLockingDocumentsPayments] = useState();


    const [documentsAlreadyInShoppingCart, setDocumentsAlreadyInShoppingCart] = useState(false);
    const [verificationsAlreadyInShoppingCart, setVerificationsAlreadyInShoppingCart] = useState(false);
    const [whatsappAlreadyInShoppingCart, setWhatsappAlreadyInShoppingCart] = useState(false);

    const [remainingAllowedTimestamps, setRemainingAllowedTimestamps] = useState(false);
    const [pendingLockingTimestampsPayments, setPendingLockingTimestampsPayments] = useState(false);

    const [organizations, setOrganizations] = useState(null)

    const [amountDepartments, setAmountDepartments] = useState(0);
    //const [allowMoreDepartments, setAllowMoreDepartments] = useState(false);

    const [askFacturacion, setAskFacturacion] = useState(false);
    const [adminEmail, setAdminEmail] = useState('');
    const [upgradePending, setUpgradePending] = useState(false);
    const [remainingDocsArr, setRemainingDocsArr] = useState([]);

    const [modal, setModal] = useState({
        open: false,
        initialState: null
    });
    const [requestModal, setRequestModal] = useState({
        open: false,
        initialState: null
    });

    const [globalDocumentsModal, setGlobalDocumentsModal] = useState({
        open: false
    })

    const [globalIdentitiesModal, setGlobalIdentitiesModal] = useState(false)
    const [whatsAppMessagesModal, setWhatsAppMessagesModal] = useState(false)

    const [globalTimestampsModal, setGlobalTimestampsModal] = useState({
        open: false
    })
    const [updateRegimenModal, setUpdateRegimenModal] = useState({
        open:false,
        invoiceId: 0
    });

    const [invoiceModal, setInvoiceModal] = useState({
        open: false,
        adminEmail: '',
        initialState: null
    });

    function handleInvoiceDataSaved() {
        setInvoiceModal({...invoiceModal, open:false})
    }

    function speiInfoModal() {
        setShowSpeiInfo({open:true});
    }

    const [shoppingCartItems, setShoppingCartItems] = useState([]);

    const fetchShoppingCart = useCallback(async () => {
        const response = await httpGet(`/shoppingCart/getShoppingCart`);
        setShoppingCartItems(response.data);

        if(response.data) {
            let docs = response.data.filter(item => item.productCode === "DT01");
            docs.length > 0 ? setDocumentsAlreadyInShoppingCart(true) : setDocumentsAlreadyInShoppingCart(false);
            let verifications = response.data.filter(item => item.productCode === "V01");
            verifications.length > 0 ? setVerificationsAlreadyInShoppingCart(true) : setVerificationsAlreadyInShoppingCart(false);
            let whastapp = response.data.filter(item => item.productCode === "W01");
            whastapp.length > 0 ? setWhatsappAlreadyInShoppingCart(true) : setWhatsappAlreadyInShoppingCart(false);
            if(response.data.length > 0) {
                setIsShoppingCartOpen(true);
            }
        }
    },[])

    function fetchAccountStatusTrigger() {
        speiInfoModal();
        fetchAccountStatus();
    }

    useEffect(() => {
        fetchShoppingCart();
    }, []);

    const fetchPendingPayments = useCallback(async () => {


        const responseDocuments = await httpGet('/payments/checkIfPendingPayments/DOCUMENTS');
        if(responseDocuments){
            setPendingLockingDocumentsPayments(responseDocuments.data.data.pending);

            if(responseDocuments.data.data.pending) {
                setRemainingAllowedDocuments(responseDocuments.data.data.remaining);
            }
        }

        const responseVerifications = await httpGet('/payments/checkIfPendingPayments/IDENTITY_VERIFICATIONS');
        if(responseVerifications){
            setPendingLockingVerificationsPayments(responseVerifications.data.data.pending);

            if(responseVerifications.data.data.pending) {
                setRemainingAllowedVerifications(responseVerifications.data.data.remaining);
            }
        }


        const responseWhatsApp = await httpGet('/payments/checkIfPendingPayments/WHATSAPP');
        if(responseWhatsApp){
            setPendingLockingWhatsAppMessagesPayments(responseWhatsApp.data.data.pending);

            if(responseWhatsApp.data.data.pending) {
                setRemainingAllowedWhatsAppMessages(responseWhatsApp.data.data.remaining);
            }
        }

        const responseTimestamps = await httpGet('/payments/checkIfPendingPayments/TIMESTAMPS');
        if(responseTimestamps){
            setPendingLockingTimestampsPayments(responseTimestamps.data.data.pending);

            if(responseTimestamps.data.data.pending) {
                setRemainingAllowedTimestamps(responseTimestamps.data.data.remaining);
            }
        }
    },[]);

    useEffect(() => {
        fetchPendingPayments()
    }, [fetchPendingPayments]);

    const fetchRemainingGlobalDocuments = useCallback(async () => {
        const response = await httpGet(`/orgs/globalDocuments/remaining`);
        setRemainingDocs({...response.data});

    },[])

    const fetchRemainingGlobalVerifications = useCallback(async () => {
        const response = await httpGet(`/orgs/globalVerifications/remaining`);
        setRemainingVerifications(response.data)

    },[])

    const fetchRemainingWhatsAppMessages = useCallback(async () => {
        const response = await httpGet(`/orgs/globalWhatsApp/remaining`);
        setRemainingWhatsAppMessages(response.data)
    }, [])

    const fetchRemainingGlobalTimestamps = useCallback(async () => {
        const response = await httpGet(`/orgs/globalTimestamps/remaining`);
        console.log('remaining global timestamps: ');
        console.log(JSON.stringify(response.data));
        setRemainingTimestamps({...response.data});

    },[]);

    const fetchAccountStatus = useCallback( async () => {
        const response = await httpGet(`/orgs/accountStanding/find`);

        if(response.data) {
            if(response.data.clientType) {
                let cType = response.data.clientType;
                if(cType === "DEMO"){
                    setMode("ALL");
                } else if(cType === "CORPORATIVO" || cType === "PERSONAL_2024" || cType === "TEAMS_2024") {
                    fetchRemainingWhatsAppMessages();
                    fetchRemainingGlobalVerifications();
                    fetchRemainingGlobalDocuments();
                    fetchRemainingGlobalTimestamps();
                    setMode("PARTIAL");
                } else if(cType === "PERSONAL") {
                    setMode("PARTIAL_PERSONAL");
                } else if(cType === "EMPRESARIAL") {
                    setMode("PARTIAL_EMPRESARIAL");
                }

                if(response.data.data) {
                    setAccountStatus({...response.data.data});
                } else if(response.data) {
                    setAccountStatus({...response.data});
                }
            } else if(response.data.data) {
                if(response.data.upgradePending) {
                    setUpgradePending(true);
                }

                if(response.data.data.status === "no_demo") {
                    //localStorage.removeItem('jwt');
                    //window.location.href = '/login';
                }

                setAccountStatus({...response.data.data});
            }
        }
        fetchPendingPayments()
    },[fetchPendingPayments, fetchRemainingGlobalTimestamps, fetchRemainingGlobalDocuments, fetchRemainingGlobalVerifications, fetchRemainingWhatsAppMessages])

    function handleGlobalDocumentsModalCancel() {
        setGlobalDocumentsModal({open:false})
    }

    async function checkIfContactNeeded() {

    }

    async function openPurchaseWindow(type) {
        try {
            const response = await httpGet('/invoiceData/getGlobalInvoicePresent');
            if(response?.data.status) {
                if(response.data.status === "no_global_invoice") {
                    setAskFacturacion(true);
                    setInvoiceModal({open:true, adminEmail: response.data.adminEmail, initialState: null});
                } else if(response.data.status === "no_invoice_with_regimen" || response.data.status === "global_selected_not_updated") {
                    setAskFacturacion(true);
                    setInvoiceModal({open:true, adminEmail: response.data.adminEmail, initialState: response.data});
                }  else if(response.data.status === "invoice_found") {
                    const responseRF = await httpGet(`/getRegimenFiscalStatus`);
                    if(responseRF) {
                        if(responseRF.data.updated) {
                            setAskFacturacion(false);
                            if(type === "documents") {
                                setGlobalDocumentsModal({open:true})
                            } else if(type === "identity") {
                                setGlobalIdentitiesModal(true);
                            } else if(type === "whatsapp") {
                                setWhatsAppMessagesModal(true);
                            }
                        } else if(responseRF.data.invoiceId) {
                            setInvoiceModal({open:true, adminEmail: responseRF.data.adminEmail, initialState: responseRF.data});
                        }
                    }
                }
            }
        } catch(e) {
        }
    }


    function handleGlobalWhatsAppAdded() {
        //fetchAccountStatus();
        setWhatsAppMessagesModal(false)
        fetchShoppingCart();
        fetchRemainingWhatsAppMessages();
    }

    function handleGlobalVerificationsAdded() {
        //fetchAccountStatus();
        setGlobalIdentitiesModal(false)
        fetchShoppingCart();
        fetchRemainingGlobalVerifications();
    }

    function handleGlobalDocumentsAdded(paymentType) {
        //fetchAccountStatus();
        setGlobalDocumentsModal({open:false});
        fetchShoppingCart();

        //fetchRemainingGlobalDocuments(); // gets the global amount of documents
    }

    function handleGlobalTimestampsModalCancel() {
        setGlobalTimestampsModal({open:false})
    }

    function handleGlobalTimestampsModalClick() {
        setGlobalTimestampsModal({open:true})
    }

    function handleGlobalTimestampsAdded() {
        setGlobalTimestampsModal({open:false});
        fetchRemainingGlobalTimestamps(); // gets the global amount of documents
    }

    useEffect(() => {
        async function fetchServerConf() {
            try {
                const response = await httpGet('/getServerConf');
                if(response?.data.jsonData) {
                    let parseConf = JSON.parse(response.data.jsonData);
                    setServerConf(parseConf);
                    const responseAllow = await httpGet('/allowPurchases');
                    if(parseConf.purchaseActive && responseAllow.data.allow) {
                        setAllowPurchases(true);
                    }
                }
            } catch(e) {
                console.error(e);
            }
        }

        async function fetchAllOrganizations() {
            if(!organizationFetchDone) {
                try {
                    const response = await httpGet('/orgsWithPlanFilter');
                    let corporativeFound = 0;
                    for(let plan of response.data) {
                        if(plan.plan.id != 1) {
                            corporativeFound++;
                        }
                    }
                    const amount = corporativeFound;
                    setAmountDepartments(amount);
                    setOrganizationsFetchDone(true);
                    /*if(amount < 5) {
                        setAllowMoreDepartments(true);
                    }*/
                    setOrganizations(response.data);
                } catch(e) {
                    console.error(e);
                    setOrganizationsFetchDone(true);
                    setOrganizations([]);
                }
            }
        }

        async function getCompanyN() {
            try {
                const response = await httpGet('/getCompanyName');
                if(response.data){
                    const responseParse = JSON.parse(response.data);
                    setCurrency(responseParse.currency);
                    setIvaIncluded(responseParse.ivaIncluded);
                    setBlockSpei(responseParse.blockSpei);
                    if(responseParse.companyName) {
                        setCompanyName(responseParse.companyName);
                    } else if(responseParse.status) {
                        if(responseParse.status === "not_updated" ){
                            setCompanyNameNotUpdated(true);
                        }
                    }
                    setCompanyId(responseParse.companyId);
                }
                setCompanyCheck(true);
            } catch(e) {
            }
        }

        async function checkInvoice() {
            const response = await httpGet(`/orgs/check/checkIfPurchasesDone`);
            if(response) {
                if(response.data.status === "UPGRADED" || response.data.status === "ERROR" || response.data.status === "CORPORATIVO") {
                    //
                } else {
                    const responseGlobal = await httpGet('/invoiceData/getGlobalInvoicePresent');
                    if(responseGlobal?.data.status) {
                        if(responseGlobal.data.status === "no_global_invoice" || responseGlobal.data.status === "no_invoice_with_regimen" || responseGlobal.data.status === "global_selected_not_updated") {
                            setAskFacturacion(true);
                        } else if(responseGlobal.data.status === "invoice_found") {
                            setAskFacturacion(false);
                        }
                    }
                }
            }
        }

        async function fetchTenant() {
            try {
                const tenant = await httpGet(`/getTenant`);
                let conf = JSON.parse(tenant.data.data.configuration);
                setTenant(conf);
            } catch(e) {
                console.error(e);
            }
        }

        fetchTenant();
        getCompanyN();
        fetchServerConf();
        fetchAllOrganizations();
        fetchAccountStatus();
        checkCompanyStatus();
        checkInvoice();
        //
        //getStatus();
    }, [fetchAccountStatus])


    useEffect(() => {
        async function subscriptionCheck() {
            if(accountStatus.clientType === "PERSONAL_2024" || accountStatus.clientType === "TEAMS_2024") {

                const responseSubscriptionActive = await httpGet('/subscriptions/checkIfSubscriptionIsActive');
                if(responseSubscriptionActive && responseSubscriptionActive.data.response){
                    setSubscriptionActiveCheck(responseSubscriptionActive.data.response);
                }
                setSubFetch(true);
            } else {
                setSubscriptionActiveCheck(false);
            }

        }
        subscriptionCheck();
    }, [accountStatus])


    useEffect(() => {

        if(!organizations) {
            return;
        }

        for(let org of organizations) {
            if(!org.organization.consumeGlobals) {
                async function getRemaningDocuments(org) {
                    try {
                        const response = await httpGet(`/orgs/${org.id}/documents/remaining`);
                        if(response) {
                            let responseData = response.data;
                            let val = {id: org.id, remaining: responseData.documents};
                            setRemainingDocsArr(rem => rem.some(item => item === val) ? rem : [...rem, val]);
                        }
                    } catch(e) {
                        console.error(e);
                    }
                }

                getRemaningDocuments(org.organization);
            }
        }
    }, [organizations]);



    async function checkCompanyStatus() {
        const responseStatus = await httpGet('/checkCompanyStatus');
        if(responseStatus){
            setCompanyActive(responseStatus.data.data.active);
            setCompanyActiveCheck(true);
        }
    }



    function handleNewOrg() {
        setModal({initialState: null, open: true, mode: "PARTIAL"})
    }

    /*function handleAdd() {
        async function checkIfPurchaseDone() {
            // Checks if there isn't a purchase done (spei or stripe)
            // if there is, this cannot be DEMO
            const response = await httpGet(`/orgs/check/checkIfPurchasesDone`);
            if(response) {
                if(response.data.status === "UPGRADED" || response.data.status === "ERROR" || response.data.status === "CORPORATIVO") {
                    window.location.reload(false);
                } else {
                    let modeCheck;
                    if(response.data.status === "NEED_UPGRADE_DATA") {
                        modeCheck = "ONLY_INFO";
                    } else {
                        modeCheck = "ALL";
                    }
                    setMode(modeCheck);

                    const responseGlobal = await httpGet('/invoiceData/getGlobalInvoicePresent');
                    if(responseGlobal?.data.status) {
                        if(responseGlobal.data.status === "no_global_invoice") {
                            setAskFacturacion(true);
                            setUpdateRegimenModal({open:true, invoiceId: null});
                        } else if(responseGlobal.data.status === "no_invoice_with_regimen" || responseGlobal.data.status === "global_selected_not_updated") {
                            setAskFacturacion(true);
                            setUpdateRegimenModal({open:true, invoiceId: responseGlobal.data.invoiceId});
                        } else if(responseGlobal.data.status === "invoice_found") {
                            const responseGlobalRF = await httpGet(`/getRegimenFiscalStatus`);
                            if(responseGlobalRF) {
                                if(responseGlobalRF.data.updated) {
                                    setModal({initialState: null, open: true, mode: modeCheck})
                                } else if(responseGlobalRF.data.invoiceId) {
                                    setUpdateRegimenModal({open:true, invoiceId: responseGlobalRF.data.invoiceId});
                                }
                            }
                        }
                    }
                }
            }
        }
        checkIfPurchaseDone();
    }*/

    function handleRequest() {
        setRequestModal({initialState: null, open: true})
    }

    function handleAlreadyExists(id) {
        history.push(`/console/orgs/${id}`);
    }

    function handleOrgSaved(newOrg) {
        window.location.reload(false);
    }

    function goToApp() {
        window.open('https://gestorescpd.chihuahua.gob.mx/pdf/default/', '_blank').focus();;
    }

    function onSaved(paymentType) {
        setAskFacturacion(false);
        setUpdateRegimenModal({open:false});
    }

    const [isShoppingCartOpen, setIsShoppingCartOpen] = useState(false);


    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <div className={'prose'}>
                        <h3>{t('WELCOME')} {companyCheck ?
                            <React.Fragment>{companyName ? <React.Fragment>{companyName}</React.Fragment> :
                                <React.Fragment>{accountStatus.name}</React.Fragment>}</React.Fragment> : null},</h3>
                    </div>
                    <div>
                        <div className={'m-5'}>
                            <Section>
                                {t('ACCOUNT_TYPE')}: {accountStatus.uiClientType}
                                {
                                    accountStatus.clientType === "DEMO" ? <React.Fragment>
                                        {
                                            accountStatus.status === "DEMO_ACTIVE" ? <React.Fragment>
                                                <br/>
                                                {t('TIME_REMAINING')}: {accountStatus.daysRemaining} {t('DAYS')}, {accountStatus.hoursRemaining} {t('HOURS')}
                                                <br/>
                                                <br/>
                                            </React.Fragment> : null
                                        }
                                        {
                                            accountStatus.status === "DEMO_OVER" ? <React.Fragment>
                                                <br/>
                                                {t('DEMO_PERIOD_CONCLUDED')}
                                            </React.Fragment> : null
                                        }
                                    </React.Fragment> : null
                                }
                                {
                                    accountStatus.clientType === "CORPORATIVO" || accountStatus.clientType === "PERSONAL_2024" || accountStatus.clientType === "TEAMS_2024" ?
                                        <div>
                                            {t('REMAINING_DOCUMENTS')}: {remainingDocs.documents} {/*({t('REMAINING_SUBSCRIPTION_DOCUMENTS')}: {remainingDocs.subscriptionDocuments})*/}
                                            {pendingLockingDocumentsPayments ?
                                                <React.Fragment> ({t('LIMITED_BY_PENDING_PAYMENT')}: {remainingAllowedDocuments} {t('AVAILABLE')})</React.Fragment>
                                                : null
                                            }
                                            <br/>
                                            {t('IDENTITY_VERIFICATIONS')}: {remainingVerifications.amount}
                                            {pendingLockingVerificationsPayments ?
                                                <React.Fragment> ({t('LIMITED_BY_PENDING_PAYMENT')}: {remainingAllowedVerifications} {t('AVAILABLE')})</React.Fragment>
                                                : null
                                            }
                                            <br/>
                                            <span>{t('WHATSAPP_MESSAGES')}</span>: {remainingWhatsAppMessages.amount}
                                            {pendingLockingWhatsAppMessagesPayments ?
                                                <React.Fragment> (<span>{t('LIMITED_BY_PENDING_PAYMENT')}</span>: {remainingAllowedWhatsAppMessages} {t('AVAILABLE')})</React.Fragment>
                                                : null
                                            }
                                            <br/>
                                            {
                                                allowPurchases && (((accountStatus.clientType === "PERSONAL_2024" || accountStatus.clientType === "TEAMS_2024") && subscriptionActive) || accountStatus.clientType === "CORPORATIVO") ?
                                                    <div className="card-actions justify-start mt-5">
                                                        <div className="dropdown">
                                                            <div tabIndex="0" role="button"
                                                                    className="btn btn-outline btn-primary">
                                                                <span>{t('BUY')}</span>
                                                            </div>
                                                            <ul tabIndex="0" className="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                                                                <DropdownItemWithPaymentLabel
                                                                    disabled={!companyActive || pendingLockingDocumentsPayments}
                                                                    pendingPayment={pendingLockingDocumentsPayments}
                                                                    onClick={() => openPurchaseWindow("documents")}>
                                                                    {t('DOCUMENTS2')}
                                                                </DropdownItemWithPaymentLabel>
                                                                <DropdownItemWithPaymentLabel
                                                                    disabled={!companyActive || pendingLockingVerificationsPayments}
                                                                    pendingPayment={pendingLockingVerificationsPayments}
                                                                    onClick={() => openPurchaseWindow("identity")}>
                                                                    {t('IDENTITY_VERIFICATIONS')}
                                                                </DropdownItemWithPaymentLabel>
                                                                <DropdownItemWithPaymentLabel
                                                                    disabled={!companyActive || pendingLockingWhatsAppMessagesPayments}
                                                                    pendingPayment={pendingLockingWhatsAppMessagesPayments}
                                                                    onClick={() => openPurchaseWindow("whatsapp")}>
                                                                    {t('WHATSAPP_MESSAGES')}
                                                                </DropdownItemWithPaymentLabel>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            {
                                                subFetch && (accountStatus.clientType === "PERSONAL_2024" || accountStatus.clientType === "TEAMS_2024") && !subscriptionActive ? <React.Fragment>
                                                    <br/>
                                                    {t('SUBSCRIPTION_INACTIVE_PURCHASES_BLOCKED')}
                                                </React.Fragment> : null
                                            }
                                        </div>
                                        : null
                                }
                                {
                                    !companyActive && companyActiveCheck ?
                                        <p style={{fontWeight: 'bold', color: 'red'}}>{t('COMPANY_DEACTIVATED')}
                                            <br/>{t('DEACTIVATED_INFO')}</p>
                                        : null
                                }
                                {
                                    upgradePending ? <React.Fragment>
                                        {t('STILL_PROCESSING')}
                                    </React.Fragment> : null
                                }

                            </Section>
                        </div>
                    </div>
                    <div className={'m-5'}>
                        <Section>
                            <div className={'prose'}>
                                {
                                    accountStatus.clientType === "PERSONAL" || accountStatus.clientType === "PERSONAL_2024"  ?
                                        <>
                                            <h3>
                                                <span>{t('DEPARTMENTS')}</span>
                                            </h3>
                                            {/*<Button disabled={!companyActive} style={{marginRight: '5px'}} color="primary"
                                                    onClick={handleAdd}>{t('CHANGE_TO_ON_DEMAND')}</Button>*/}
                                        </> : null
                                }
                                {

                                    accountStatus.clientType === "CORPORATIVO" || accountStatus.clientType === "EMPRESARIAL" || accountStatus.clientType === "TEAMS_2024" ?
                                        <>
                                            <h3>{t('DEPARTMENTS')}</h3>
                                            <div className={'flex-col space-y-2 md:space-x-2'}>
                                                <button className={'btn btn-secondary'} disabled={!companyActive}  onClick={handleNewOrg}>
                                                    {t('CREATE_DEPARTMENT')}
                                                </button>
                                                {/*<Link to={`subscriptions`}
                                                      className={'btn btn-secondary'} disabled={!companyActive}>
                                                    {t('SUBSCRIPTIONS')}
                                                </Link>*/}
                                            </div>
                                        </>
                                        : null
                                }
                            </div>
                    <p>
                    {
                        accountStatus.clientType === "CORPORATIVO" || accountStatus.clientType === "EMPRESARIAL" ?
                            <React.Fragment>
                                <br/>
                                {t('DEPARTMENTS_CREATED')}: {amountDepartments}
                            </React.Fragment> : null
                    }
                    {/*
                        accountStatus.clientType === "PERSONAL" ? <React.Fragment>
                            {t('MODIFY_SUBSCRIPTION')}
                        </React.Fragment> : null
                    */}
                    </p>
                    {
                        tenant && accountStatus.clientType === 'DEMO' ?
                            askFacturacion ?
                            <UpdateRegimenFiscalInline
                                invoiceId={updateRegimenModal.invoiceId}
                                onSaved={onSaved} /> :
                            <BuyGlobalDocumentsInline
                                onCancel={handleGlobalDocumentsModalCancel}
                                onSaved={handleGlobalDocumentsAdded}
                                companyActive={companyActive}
                                mode="ONLY_DOCS"
                                org={null}
                                pendingPayments={pendingLockingDocumentsPayments}
                                askFacturacion={askFacturacion}
                                tenant={tenant}
                                currency={currency}
                                includeTax={ivaIncluded}
                            ></BuyGlobalDocumentsInline>
                            : null
                    }
                    {
                        accountStatus.clientType !== "DEMO" ?
                            <SectionList collection={organizations}
                                         noData={<p>{t('NONE')}</p>}>
                                {
                                    organizations && organizations.map(org => (
                                        <div key={org.organization.id}>
                                            <Link to={`orgs/${org.organization.id}`} style={{cursor: 'pointer'}} className={'link link-primary'}>
                                                <p style={{fontWeight: 'bold'}}>{org.organization.organizationName} </p>
                                            </Link>
                                            {
                                                !org.organization.consumeGlobals ? <React.Fragment>
                                                    {t('DEPARTMENT_DOES_NOT_CONSUME_GLOBALS')}
                                                    <br/>
                                                    {t('REMAINING_DOCUMENTS')}: {
                                                    remainingDocsArr.filter(val => val.id === org.organization.id).map(valF => (
                                                        <span key={valF.id}>{valF.remaining}</span>
                                                    ))
                                                }
                                                </React.Fragment> : null
                                            }
                                        </div>
                                    ))
                                }
                            </SectionList> : null
                    }

                        </Section>
                    </div>
                    <BuyGlobalDocumentsModal
                        isOpen={globalDocumentsModal.open}
                        onCancel={handleGlobalDocumentsModalCancel}
                        onSaved={handleGlobalDocumentsAdded}
                        companyActive={companyActive}
                        mode="ONLY_DOCS"
                        org={null}
                        pendingPayments={pendingLockingDocumentsPayments}
                        askFacturacion={askFacturacion}
                        tenant={tenant}
                        documentsAlreadyInShoppingCart={documentsAlreadyInShoppingCart}
                        currency={currency}
                        includeTax={ivaIncluded}
                    />

                    <BuyGlobalWhatsAppMessages
                        isOpen={whatsAppMessagesModal}
                        onCancel={() => setWhatsAppMessagesModal(false)}
                        onSaved={handleGlobalWhatsAppAdded}
                        companyActive={companyActive}
                        org={null}
                        tenant={tenant}
                        whastappAlreadyInShoppingCart={whatsappAlreadyInShoppingCart}
                        currency={currency}
                        includeTax={ivaIncluded}
                        pendingPayments={pendingLockingWhatsAppMessagesPayments}
                        />

                    <BuyGlobalIdentityVerificationsModal
                        isOpen={globalIdentitiesModal}
                        onCancel={() => setGlobalIdentitiesModal(false)}
                        onSaved={handleGlobalVerificationsAdded}
                        companyActive={companyActive}
                        org={null}
                        tenant={tenant}
                        verificationsAlreadyInShoppingCart={verificationsAlreadyInShoppingCart}
                        currency={currency}
                        includeTax={ivaIncluded}
                        pendingPayments={pendingLockingVerificationsPayments}
                    />
                    <OrganizationModal
                        isOpen={modal.open}
                        initialState={modal.initialState}
                        onCancel={() => setModal({initialState: null, open: false})}
                        onSaved={handleOrgSaved}
                        alreadyExists={handleAlreadyExists}
                        companyActive={companyActive}
                        mode={mode}
                        companyName={companyName}
                        companyNameNotUpdated={companyNameNotUpdated}
                        askFacturacion={askFacturacion}
                        tenant={tenant}
                    />
                </div>
                <InvoiceDataModal
                    isOpen={invoiceModal.open}
                    initialState={invoiceModal.initialState}
                    adminEmail={invoiceModal.adminEmail}
                    onCancel={() => setInvoiceModal({initialState: null, open: false})}
                    onSaved={handleInvoiceDataSaved}
                    dataNeeded={true} />
                {/*<UpdateRegimenFiscal
                    isOpen={updateRegimenModal.open}
                    invoiceId={updateRegimenModal.invoiceId}
                    onSaved={onSaved}
                ></UpdateRegimenFiscal>*/}
                <DepartmentRequestModal
                    isOpen={requestModal.open}
                    initialState={requestModal.initialState}
                    onCancel={() => setRequestModal({initialState: null, open: false})}
                    companyActive={companyActive} />
                <SpeiInfoModal
                    isOpen={showSpeiInfo.open}
                    onClose={() => setShowSpeiInfo({open:false})}></SpeiInfoModal>
            </div>
        </div>
    )
}

function AssignDocuments({orgId, onDocumentsAssigned, orgName}) {

    const [modal, setModal] = useState({
        open: false
    })

    const [planData, setPlanData] = useState({
        plan: {}
    });

    const [remainingDocs, setRemainingDocs] = useState({});

    function handleModalCancel() {
        setModal({open:false})
    }

    function handleAssignDocumentsClick() {
        setModal({open:true})
    }

    function handleDocumentsAssigned() {
        setModal({open:false});
        fetchRemainingDocuments();
        onDocumentsAssigned();
    }

    useEffect(() => {
        window.scrollTo(0,0);
        fetchPlan();
    }, [])


    async function fetchRemainingDocuments() {
        const response = await httpGet(`/orgs/${orgId}/documents/remaining`);
        setRemainingDocs({...response.data});
    }


    async function fetchPlan() {
        const response = await httpGet(`/orgs/${orgId}/plan`);
        setPlanData(response.data);

        if(response.data.plan.name === "CORPORATIVO") {
            fetchRemainingDocuments();
        }
    }

    return (
        <div className="container">
            {
                planData.plan.name === "CORPORATIVO" ?
                    <div className="row align-items-center">
                        <div className="col">
                            <div>Documentos restantes: {remainingDocs.documents}</div>
                        </div>
                        <div className="col">
                            <div className="row justify-content-end">
                            <Button outline
                                onClick={handleAssignDocumentsClick}
                                color="primary">Asignar documentos</Button>
                            </div>
                        </div>
                        <AssignDocumentsModal
                            isOpen={modal.open}
                            onCancel={handleModalCancel}
                            onSaved={handleDocumentsAssigned}
                            orgId={orgId}
                            orgName={orgName}
                        />
                    </div>
                 : null
            }
        </div>
    )
}

function AssignTimestamps({orgId, onTimestampsAssigned, orgName}) {

    const [modal, setModal] = useState({
        open: false
    })

    const [planData, setPlanData] = useState({
        plan: {}
    });

    const [remainingTimestamps, setRemainingTimestamps] = useState({});
    const [stampsActive, setStampsActive] = useState(false);

    function handleModalCancel() {
        setModal({open:false})
    }

    function handleAssignTimestampsClick() {
        setModal({open:true})
    }

    function handleTimestampsAssigned() {
        setModal({open:false});
        fetchRemainingTimestamps();
        onTimestampsAssigned();
    }

    useEffect(() => {
        window.scrollTo(0,0);
        fetchPlan();
    }, [])

    function handleActivateStamps() {
        async function fetchOrgData() {
            const response = await httpGet(`/orgs/${orgId}/config/activateTimestamps`)

            if(response.data) {
                const dataJson = response.data;
                if(dataJson.success) {
                    setStampsActive(true);
                }
            }
        }
        fetchOrgData();
    }

    function checkConfig(){
        async function fetchConfig() {
            try {
                const response = await httpGet(`/orgs/${orgId}/config/nom151FinalStamp`);
                if(response.data.data){
                    const dataJson = response.data.data;
                    if(dataJson.stamp) {
                        setStampsActive(true);
                    } else {
                        setStampsActive(false);
                    }
                }
                //setStamper(serverConfig);
            } catch(e) {
                setStampsActive(false)
            }
        }
        fetchConfig();
    }

    async function fetchRemainingTimestamps() {
        const response = await httpGet(`/orgs/${orgId}/timestamps/remaining`);
        console.log('remaining docs: ');
        console.log(JSON.stringify(response.data));
        setRemainingTimestamps({...response.data});
    }

    async function fetchPlan() {
        const response = await httpGet(`/orgs/${orgId}/plan`);
        setPlanData(response.data);

        if(response.data.plan.name === "CORPORATIVO") {
            fetchRemainingTimestamps();
            checkConfig();
        }
    }

    return (
        <div className="container">
            {
                planData.plan.name === "CORPORATIVO" ? <React.Fragment>
                {
                    stampsActive ?
                        <div className="row align-items-center">
                            <div className="col">
                                <div>Sellos NOM151 restantes: {remainingTimestamps.timestamps}</div>
                            </div>
                            <div className="col">
                                <div className="row justify-content-end">
                                <Button outline
                                    onClick={handleAssignTimestampsClick}
                                    color="primary">Asignar sellos NOM151</Button>
                                </div>
                            </div>
                            <AssignTimestampsModal
                                isOpen={modal.open}
                                onCancel={handleModalCancel}
                                onSaved={handleTimestampsAssigned}
                                orgId={orgId}
                                orgName={orgName}
                            />
                        </div>
                    :
                        <div className="row align-items-center">
                            <div className="col">
                                <div>Las sellos NOM151 estan desactivadas para esta cuenta.</div>
                            </div>
                            <div className="col">
                                <div className="row justify-content-end">
                                <Button outline
                                    onClick={handleActivateStamps}
                                    color="primary">Activar sellos NOM151</Button>
                                </div>
                            </div>
                        </div>

                }
                </React.Fragment> : null
            }
        </div>
    )
}

export default Organizations;
